import { Anchor } from '@components/Anchor';
import { DataTable } from '@components/Table/DataTable';
import { Pagination } from '@components/Table/Pagination';
import { TableCellAction } from '@components/Table/TableCellAction';
import { TableHeaderCellAction } from '@components/Table/TableHeaderCellAction';
import { TableKeyCell } from '@components/Table/TableKeyCell';
import { TableSortCell } from '@components/Table/TableSortCell';
import { TableSortRow } from '@components/Table/TableSortRow';
import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { IMenu } from '@hooks/useMenu';
import { useModalWindow } from '@hooks/useModalWindow';
import { TableBody, TableCell, TableContainerProps, TableHead, TableRow } from '@material-ui/core';
import { IExcedente, useExcedenteStatusColor } from '@model/Excedente';
import { IExcedenteFilter } from '@services/ExcedenteService';
import React from 'react';
import { ExcedenteDetalheModal } from './ExcedenteDetalheModal';

export type ExcedenteTableProps = {
    isLoading: boolean
    data: IData<IExcedente, IExcedenteFilter>
    tableContainerProps?: TableContainerProps
    menu: IMenu
}

export function ExcedenteTable ({ isLoading, data, tableContainerProps, menu }: ExcedenteTableProps) {
    const formatter = useFormatter();
    const excedenteStatusColor = useExcedenteStatusColor();

    const excedenteDetalheModal = useModalWindow();

    return (
        <React.Fragment>
            <DataTable 
                isLoading={isLoading} 
                itemCount={data.itemsCount}
                tableContainerProps={tableContainerProps}
            >
                <TableHead>
                    <Pagination pagination={data.pagination} />

                    <TableSortRow sort={data.sort}>
                        <TableSortCell fieldName="excedeteId">ID</TableSortCell>
                        <TableSortCell fieldName="nomeArquivo">Nome Arquivo</TableSortCell>
                        <TableSortCell fieldName="competencia">Comp. Referência</TableSortCell>
                        <TableSortCell fieldName="inicio">Abertura</TableSortCell>
                        <TableSortCell fieldName="termino">Fechamento</TableSortCell>
                        <TableSortCell fieldName="status">Status</TableSortCell>
                        <TableHeaderCellAction />
                    </TableSortRow>
                </TableHead>
                
                <TableBody>
                    {
                        data.items.map((excedente, index) => {
                            return (
                                <TableRow key={index}>
                                    <TableKeyCell><Anchor onClick={data.handleRowFocused(excedente, excedenteDetalheModal.open)}>{excedente.excedenteId}</Anchor></TableKeyCell>
                                    <TableCell>{excedente.nomeArquivo}</TableCell>
                                    <TableCell>{formatter.toCompetencia(excedente.competencia)}</TableCell>
                                    <TableCell>{formatter.toDate(excedente.inicio)}</TableCell>
                                    <TableCell>{formatter.toDate(excedente.termino)}</TableCell>
                                    <TableCell className={excedenteStatusColor[excedente.status.value]}>{excedente.status.description}</TableCell>
                                    <TableCellAction onButtonClick={data.handleRowFocused(excedente, menu.open)} />
                                </TableRow>
                            )
                        })
                    }
                    <Pagination pagination={data.pagination} />
                </TableBody>
            </DataTable>

            {
                data.focusedRow !== undefined && (
                    <ExcedenteDetalheModal 
                        excedenteId={data.focusedRow.excedenteId}
                        modal={excedenteDetalheModal}
                    />
                )
            }
        </React.Fragment>
    )
}